import { Image } from "@mantine/core";
import mantaClassicLogo from "../../assets/Manta_Classic_appicon.png"

const LogoHeader = () => (
  <Image
    className="logo-manta-classic mx-auto mb-3"
    src={mantaClassicLogo}
    style={{
      height: 57,
      width: 57,
      alignSelf: "center",
      borderRadius: 10
    }}
  />
);
export default LogoHeader;
